module.exports = __webpack_public_path__ + "static/about_image-d6827f84c7cd6cd4c3a4a1543a05c99d.jpg";